import { getApiFromModule } from "./GetContentsByModule";
import { Share } from "react-native";
import { getTranslatedString } from "./FindifyTranslatedString";
import { SimpleHeaderAction } from "../components/FindifySimpleHeader";

// Some public endpoints still return records disabled in the backoffice.
// Treat an omitted flag as public, but exclude every explicit inactive value.
export const isVisiblePublicItem = (item: any) => {
    const isExplicitlyDisabled = (value: any) => value === false || value === 0 || value === '0' || value === 'false';
    return !isExplicitlyDisabled(item?.active)
        && !isExplicitlyDisabled(item?.published)
        && !isExplicitlyDisabled(item?.is_active)
        && !isExplicitlyDisabled(item?.is_published)
        && item?.status !== 'inactive';
};

// Keep the visitor-facing lists aligned with the publication schedule set in
// the backoffice. Undated entries follow dated ones without changing their
// relative API order.
export const sortByPublicationDateDescending = <T,>(items: T[]): T[] => (
    [...items].sort((left: any, right: any) => {
        const leftTime = Date.parse(left?.make_public_on ?? '');
        const rightTime = Date.parse(right?.make_public_on ?? '');
        const leftValue = Number.isFinite(leftTime) ? leftTime : Number.NEGATIVE_INFINITY;
        const rightValue = Number.isFinite(rightTime) ? rightTime : Number.NEGATIVE_INFINITY;
        return rightValue - leftValue;
    })
);

export const PlaceListInitialUseEffect = ({
    props,
    setContents,
    setLoaded,
    setModule,
    setSelectedCategories,
    findifyDataContext,
    setAvailableModuleCategories,
    contents,
    ignoreContentsWithoutCategory,
    pageModule,
}: {
    props: any,
    setContents: Function,
    setLoaded: Function,
    setModule: Function,
    setSelectedCategories: Function,
    findifyDataContext: any,
    setAvailableModuleCategories: Function,
    contents: any
    ignoreContentsWithoutCategory?: boolean,
    pageModule?: string,
}) => {
    const module = props?.route?.params?.module ?? pageModule;
    const category = props?.route?.params?.category;
    setModule(module);
    let selectedCats: number[] = [];
    if (category && category !== '') {
        selectedCats = [+category];
        setSelectedCategories(selectedCats);
    }
    const categoriesApi = getApiFromModule('categories', findifyDataContext);
    // On category change 
    categoriesApi.getList(0, 300, null, { category_type: `${module}`, active: 1 }, null).then((data: any) => {
        setAvailableModuleCategories(sortByPublicationDateDescending((data?.results ?? []).filter(isVisiblePublicItem)));
    })

    if (!ignoreContentsWithoutCategory) {
        loadContentsPageFromApi(selectedCats, contents, module, findifyDataContext, setContents).then(() => {
            setLoaded(true);
        });
    } else {
        setLoaded(true);
    }
}

export const PlaceListOnSelectedCategoryChangeEffect = ({
    loaded,
    selectedCategories,
    setContents,
    module,
    findifyDataContext,
    setActionsList,
    availableModuleCategories,
    t,
}: {
    loaded: boolean,
    selectedCategories: number[],
    setContents: Function,
    module: string,
    findifyDataContext: any,
    setActionsList: (actionsList: SimpleHeaderAction[]) => void,
    availableModuleCategories: any[],
    t: Function
}) => {
    // On category change reset current items
    if (loaded) {
        setContents([]);
        loadContentsPageFromApi(selectedCategories, [], module, findifyDataContext, setContents);
    }

    setActionsList([{
        icon: 'share-outline',
        action: async () => {
            const result = await Share.share({
                title: (selectedCategories.length === 1 ?
                    getTranslatedString(
                        availableModuleCategories.find((cat: any) => cat.category_id === selectedCategories[0])?.name, findifyDataContext) :
                    t('modules.content_types.' + module)) + ' - ' + getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
                message: `https://${findifyDataContext.workspace?.primary_domain?.domain_name ?? 'links.findify.cloud'}/dynamicLink?workspace_id=${findifyDataContext.workspace?.workspace_id}&type=list&module=${module}${selectedCategories.length === 1 ? `&category_id=${selectedCategories[0]}` : ''}`,
            }, {
                dialogTitle: getTranslatedString(findifyDataContext?.workspace?.name, findifyDataContext) + ' - Findify',
            });
        }

    }]);
}

export const loadContentsPageFromApi = async (selectedCategories: number[], listItems: any[], module: string, findifyDataContext: any, setListItems: Function) => {
    const api = getApiFromModule(module, findifyDataContext);
    // On category change(first load also)
    let filters = {};
    if (selectedCategories.length !== 0) {
        filters = { 'categories.category.category_id_in': JSON.stringify(selectedCategories) }
    }
    const data = await api?.getList(listItems.length, 50, null, filters, null);
    setListItems(sortByPublicationDateDescending([...listItems, ...(data?.results ?? []).filter(isVisiblePublicItem)]));
}
